<div class="date-picker border-light-bottom" #datePickerOrigin>
    <button class="pl-0 pl-0 content-m border-none placeholder-text" [ngClass]="isDisabled ? '':'selected lightest-text'" (click)="chooseDates_click(datePickerOrigin)"> Choose Dates </button>
    </div>   